import { CAT_COMPANY_NEWS } from 'App/utils/Collections';
import { FT_DATE, FT_AUTOCOMPLETE, FT_LIST } from '../FilterTypes';
import { searchNewsDomains, searchNewsTags } from './loaders';
import { ROLE_STAFF } from '@/app/constants/Roles';

const groups = {
  general: {
    name: 'General',
    groupOrderIndex: 0,
  },
  date: {
    name: 'Date',
    groupOrderIndex: 1,
  },
};

export default {
  category: CAT_COMPANY_NEWS,
  filters: [
    {
      id: 'snippetDate',
      type: FT_DATE,
      label: 'Published on',
      group: groups.date,
    },
    {
      id: 'domain.id',
      label: 'Domain',
      group: groups.general,
      type: FT_AUTOCOMPLETE,
      placeholder: 'Choose domain',
      fieldConf: {
        multiple: false,
        deletebleChips: true,
        chips: true,
        searcher: searchNewsDomains,
      },
    },
    {
      id: 'tags.id',
      label: 'Tags',
      group: groups.general,
      type: FT_LIST,
      placeholder: 'Choose tags',
      roles: [ROLE_STAFF],
      getListItems: searchNewsTags,
    },
  ],
  searchBarProp: 'complex_name',
};
